import React from 'react';
import {
  Text,
  Button,
  Flex,
  Image,
  useToast,
  Td,
  Tr,
  Spacer,
  Tooltip,
  Input,
  Select,
} from '@chakra-ui/react';
import { customSwtich } from '../components/createAppVersionComponent/createAppVersionComponent';
import style from '../components/common/style';
import { ChecktableTwo } from '../components/common/ChecktableTwo';
import { colBlackAppPage } from '../context/data';
import { useHistory } from 'react-router-dom';
import { MiniHeader } from '../components/common/customComponent';
import LangContext from '../context/languageContext';
import ApiManager from '../config/apiManager';
import { ArrowUpIcon, ArrowDownIcon } from '@chakra-ui/icons';
import { options } from '../context/data';
import config from '../config/config';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import { deleteImage } from '../config/imageUploader';

const BlackAppPage = () => {
  // let initialValue = {
  //   Suggestion: '',
  // };
  let history = useHistory();
  const [dataa, setDataa] = React.useState([]);
  const [suggest, setsuggest] = React.useState('');
  const { currentLangData } = React.useContext(LangContext);
  const [success, setSuccess] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [value, setValue] = React.useState('10');
  const [paginat, setpaginate] = React.useState();
  const [loader, setLoader] = React.useState(false);
  let apimanager = ApiManager.getInstance();
  const toast = useToast();
  // Creating Variable //
  let tempArray = [];
  const handleOnChange = (evt, key) => {
    const ev = evt.target.value;
    setValue(ev);
  };
  React.useEffect(() => {
    getALLItems(value, 1);
  }, [value]);
  console.log('suggest>>', suggest);
  const handleonSwitch = (evt, key, id) => {
    const ev = evt;
    console.log('Switch', ev, 'key', key, 'id', id);
    setsuggest(ev);
    // setValue({
    //   ...value,
    //   [key]: ev,
    // });
  };
  const ArrowUp = ID => {
    let index = dataa.findIndex(e => e._id === ID); //find id from Api
    // console.log("Index",index,"id",ID)
    if (index > 0) {
      let el = dataa[index];
      dataa[index] = dataa[index - 1];
      dataa[index - 1] = el;
      // console.log("EL>>",el,"Up>>>",dataa[index])
      setDataa([...dataa]);
    }
  };

  const ArrowDown = ID => {
    let index = dataa.findIndex(e => e._id === ID); //find id from Api
    // console.log("Index",index,"id",ID)
    if (index >= 0) {
      let el = dataa[index];
      dataa[index] = dataa[index + 1];
      dataa[index + 1] = el;
      // console.log("EL>>",el,"Up>>>",dataa[index])
      setDataa([...dataa]);
    }
  };
  // const deleteImagefile = e => {
  //   // setShow(true);
  //   console.log('e.target=>', e);
  //   deleteImage(e)
  //     .then(res => {
  //       console.log('image uri', res);
  //       // setS3Image(e.target.files[0].name);
  //       // setShow(false);
  //     })
  //     .catch(error => {
  //       console.log('error', error);
  //     });
  // };

  const getALLItems = (limit, page) => {
    setLoader(false);
    const body = {
      numRecords: limit,
      page: page,
    };
    apimanager
      .get('getAllBAPages', body)
      .then(res => {
        console.log('res', res);
        if (res.message === 8272) {
          res?.results?.docs?.map((value, index) => {
            tempArray.push(value);
          });
          setDataa(tempArray);
          setpaginate(res?.results);
          setLoader(true);
        }
      })
      .catch(error => {
        console.log('error', error);
        setLoader(true);
      });
  };
  const deleteItem = item => {
    console.log('Deletion done', item.id);
    let apimanager = ApiManager.getInstance();
    const body = {
      id: item._id,
    };
    console.log('body>>>>', body);
    apimanager
      .post('deleteBlackAppPage', body)
      .then(response => {
        if (response.message === 8268) {
          setSuccess('Successfully Deleted!');
          toast({
            title: success,
            status: 'success',
            duration: 3000,
            isClosable: true,
            description: `Deleted, Please processed to List!`,
          });
          getALLItems();
        }
      })
      .catch(error => {
        console.log(error);
      });
  };
  const onClickSubmit = item => {
    const body = {
      id: item?._id,
      // suggested: suggest,
    };
    console.log('body>>>>', body);
    apimanager
      .post('suggestionOnOff', body)
      .then(response => {
        console.log(response, 'response');
        if (response.message === 8643) {
          // setLoading(false);
          setSuccess('Successfully Submitted');
          toast({
            title: success,
            status: 'success',
            duration: 3000,
            isClosable: true,
            description: `Submitted, Please processed to List!`,
          });
          setTimeout(() => {
            getALLItems(value, 1);
          });
        }
        if (response.message === 5068) {
          setError('Failed');
          toast({
            title: error,
            status: 'error',
            duration: 3000,
            isClosable: true,
            description: `Something Went Wrong`,
          });
        }
      })
      .catch(error => {
        // setLoading(false);
        console.log(error);
      });
  };
  return (
    <Flex flexDirection={'column'}>
      <Flex {...style.miniheader}>
        {MiniHeader({
          title: 'Black App Page',
          path: 'Dashboard',
          onclickForRoute: () => history.push('/Dashboard'),
          path1: 'Black App Page',
        })}
      </Flex>
      <Flex {...style.box} background={'#fafdfb'} padding={10}>
        <Flex {...style.main}>
          <Flex {...style.buttoncontainer}>
            <Button
              {...style.createbutton}
              onClick={() => history.push('/CreateBlackAppPage')}
            >
              Create
            </Button>
          </Flex>
          <Flex {...style.optionFlex}>
            <Flex {...style.showentries} alignItems={'center'} fontSize={'sm'}>
              <Text>{currentLangData?.app?.show}</Text>
              <Select
                {...style.select}
                onChange={e => handleOnChange(e, 'numrecords')}
              >
                {options.map(option => (
                  <option value={option.value}>{option.label}</option>
                ))}
              </Select>
              <Text>{currentLangData?.app?.entries}</Text>
            </Flex>
            <Spacer />
            <Flex alignItems={'center'} {...style.showentries}>
              {/* <Text paddingY={'5px'}>{currentLangData?.app?.search}:</Text> */}
              {/* <Input {...style.searchinput}></Input> */}
            </Flex>
          </Flex>

          <ChecktableTwo
            datalist={dataa}
            TotDocs={paginat}
            loaderr={loader}
            headerNames={colBlackAppPage}
            onPageChange={page => getALLItems(value, page)}
            renderItem={({ item, index }) => {
              console.log('renderitem', item);
              return (
                <Tr key={index} width={'100%'}>
                  <Td>{item?.title}</Td>
                  <Td>{item?.category}</Td>
                  <Td width={30}>
                    <Tooltip label={item?.description} >
                      <Text noOfLines={1}>
                      {item?.description}
                      </Text>
                    </Tooltip>
                  </Td>
                  <Td>
                    <Image
                      borderRadius="full"
                      boxSize="40px"
                      src={process.env.REACT_APP_S3URL + item?.icon}
                    ></Image>
                  </Td>
                  <Td
                    display={1}
                    justifyContent={'center'}
                    alignItems={'center'}
                  >
                    <ArrowUpIcon
                      w={5}
                      h={5}
                      color={'#ffa426 '}
                      cursor={'pointer'}
                      onClick={() => {
                        ArrowUp(item?._id);
                      }}
                    />
                    <ArrowDownIcon
                      w={5}
                      h={5}
                      color={'#ffa426 '}
                      cursor={'pointer'}
                      onClick={() => {
                        ArrowDown(item._id);
                      }}
                    />
                  </Td>
                  <Td
                    display={1}
                    justifyContent={'center'}
                    alignItems={'center'}
                  >
                    {customSwtich({
                      checked: item?.isSuggestion,
                      check: e => {
                        onClickSubmit(item);
                      },
                    })}
                  </Td>
                  <Td
                    // position={'relative'}
                    // display={'inline-flex'}
                    // verticalAlign={'middle'}
                    display={1}
                    justifyContent={'center'}
                    alignItems={'center'}
                  >
                    <Tooltip label={currentLangData?.app?.edit}>
                      <Button
                        {...style.editbtn}
                        leftIcon={<EditIcon />}
                        onClick={() =>
                          history.push({
                            pathname: '/CreateBlackAppPage',
                            status: 'create',
                            state: { val: item },
                          })
                        }
                      ></Button>
                    </Tooltip>
                    <Tooltip label={currentLangData?.app?.delete} bg={'red'}>
                      <Button
                        {...style.Delbtn}
                        leftIcon={<DeleteIcon />}
                        onClick={() => deleteItem(item)}
                      ></Button>
                    </Tooltip>
                  </Td>
                </Tr>
              );
            }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
export default BlackAppPage;
